/**
 * A request body for the POST search routes (#2025, #2028): the given fields
 * minus undefined and null ones, so the server applies its own defaults, as it
 * would for a parameter left out of a GET query string.
 */
export const definedFields = <T extends object>(params: T): Partial<T> =>
  Object.fromEntries(
    Object.entries(params).filter(([, value]) => value !== undefined && value !== null),
  ) as Partial<T>;
